import React from 'react'
import img from './the img/img'

function Project() {
  return (
    <div>
        <nav className='navbar navbar-expand-lg navbar-dark bg-primary'>
            <div className="container">
                <a class="navbar-brand" href='#'>Dev Godwin</a>
                <button className='navbar-toggler' type='button' data-toogle='collapse' data-target='#navbarSupportedContent'>
                    <span className='navbar-toggler-icon'></span>
                </button>

                <div className='collapse navbar-collapse' id='navbarSupportedContent'>
                <ul class="navbar-nav ml-auto">
                    <li className="nav-item">
                    <a href="" className='nav-link'>Home</a>
                    </li>
                    <li className='nav-item dropdown'>
                    <a href="/about" className='nav-link dropdown-toggle' id='navbarDropdown' data-toggle='dropdown'>About</a>
                    <div className="dropdown-menu">
                        <a href="https://github.com/webgod1" className="dropdown-item">Github Link</a>
                        <a href="https://www.linkedin.com/in/godwin-samuel479723254" className="dropdown-item">LinkedIn Link</a>
                        <a href="https://twitter.com/godwinsam2006" className="dropdown-item">Twitter Link</a>
                        <div className="dropdown-divider"></div>
                        <a href="/about" className="dropdown-item">About Link</a>

                    </div>
                    </li>
                    <li className='nav-item'>
                    <a href="/project" className='nav-link'>Projects</a>
                    </li>
                    <li className='nav-item'>
                    <a href="#" className='nav-link'>Contact Me</a>
                    </li>
                </ul>
                </div>
            </div>
         </nav>
         <div className='container'>
            <h3 className='display-6 text-center mt-4'>Here Are Some Project I worked On</h3>
            <div className='row'>
                        <div className='col-lg-4 col-sm-12 col-xs-12 mt-4'>
                            <div className='card'>
                                <img className='text-center ml-3 mt-1' style={{width: '95%', borderRadius: '10px', height: '90%'}} src={img[2]} alt="" />
                                <h2 className='mt-2 ml-2'>Yelp Camp</h2>
                                <p className='mt-2 ml-2'>A website for camping, adventure and new experience for everyone. Built with React.js and Firebase</p>
                                <button className='btn btn-primary'>Check Out</button>
                                <a href='#' className='btn btn-primary mt-2'>Github</a>
                            </div>
                        </div>
                        <div className='col-lg-4 col-sm-12 col-xs-12 mt-4'>
                            <div className='card'>
                                <img className='text-center ml-3 mt-1' style={{width: '95%', borderRadius: '10px', height: '90%'}} src={img[3]} alt="" />
                                <h2 className='mt-2 ml-2'>Twitter Data Analysis</h2>
                                <p className='mt-2 ml-2'>A Twitter Clone website.  Built with HTML, CSS AND JAVASCRIPT</p>
                                <button className='btn btn-primary'>Check Out</button>
                                <a href='#' className='btn btn-primary mt-2'>Github</a>
                            </div>
                        </div>
                        <div className='col-lg-4 col-sm-12 col-xs-12 mt-4'>
                            <div className='card'>
                                <img className='text-center ml-3 mt-1' style={{width: '95%', borderRadius: '10px', height: '90%'}} src={img[4]} alt="" />
                                <h2 className='mt-2 ml-2'>TicTaTook Game</h2>
                                <p className='mt-2 ml-2'>A Super fun game. Built with HTML, CSS and javascript</p>
                                <button className='btn btn-primary'>Check Out</button>
                                <a href='#' className='btn btn-primary mt-2'>Github</a>
                            </div>
                        </div>
                </div>

                <div className='row'>
                        <div className='col-lg-4 col-sm-12 col-xs-12 mt-4'>
                            <div className='card'>
                                <img className='text-center ml-3 mt-1' style={{width: '95%', borderRadius: '10px', height: '90%'}} src={img[5]} alt="" />
                                <h2 className='mt-2 ml-2'>Tizeti Clonning</h2>
                                <p className='mt-2 ml-2'>A website free wifi website. Built with HTML,CSS,JAVASCRIPT</p>
                                <button className='btn btn-primary'>Check Out</button>
                                <a href='#' className='btn btn-primary mt-2'>Github</a>
                            </div>
                        </div>
                        <div className='col-lg-4 col-sm-12 col-xs-12 mt-4'>
                            <div className='card'>
                                <img className='text-center ml-3 mt-1' style={{width: '95%', borderRadius: '10px', height: '90%'}} src={img[6]} alt="" />
                                <h2 className='mt-2 ml-2'>Foods Ready</h2>
                                <p className='mt-2 ml-2'>A website that sells food, straight delivery.  Built with React AND Firebase, An assignment on Side hustle Internship</p>
                                <button className='btn btn-primary'>Check Out</button>
                                <a href='#' className='btn btn-primary mt-2'>Github</a>
                            </div>
                        </div>
                        <div className='col-lg-4 col-sm-12 col-xs-12 mt-4'>
                            <div className='card'>
                                <img className='text-center ml-3 mt-1' style={{width: '95%', borderRadius: '10px', height: '90%'}} src={img[2]} alt="" />
                                <h2 className='mt-2 ml-2'>Portfolio</h2>
                                <p className='mt-2 ml-2'>My personal porfolio. Built with React, An assignment on Side Huslte Internship</p>
                                <button className='btn btn-primary'>Check Out</button>
                                <a href='#' className='btn btn-primary mt-2'>Github</a>
                            </div>
                        </div>
                </div>
                <div className='row'>
                        <div className='col-lg-4 col-sm-12 col-xs-12 mt-4 mb-3'>
                            <div className='card'>
                                <img className='text-center ml-3 mt-1' style={{width: '95%', borderRadius: '10px', height: '90%'}} src={img[6]} alt="" />
                                <h2 className='mt-2 ml-2'>React Slider</h2>
                                <p className='mt-2 ml-2'>A Responsive react slider. Built with React.js</p>
                                <button className='btn btn-primary'>Check Out</button>
                                <a href='#' className='btn btn-primary mt-2'>Github</a>
                            </div>
                        </div>
                        <div className='col-lg-4 col-sm-12 col-xs-12 mt-4 mb-3'>
                            <div className='card'>
                                <img className='text-center ml-3 mt-1' style={{width: '95%', borderRadius: '10px', height: '90%'}} src={img[1]} alt="" />
                                <h2 className='mt-2 ml-2'>React Note Book</h2>
                                <p className='mt-2 ml-2'>A Complete React NoteBook.  Built with React(Along with local storage).</p>
                                <button className='btn btn-primary'>Check Out</button>
                                <a href='#' className='btn btn-primary mt-2'>Github</a>
                            </div>
                        </div>
                        <div className='col-lg-4 col-sm-12 col-xs-12 mt-4 mb-3'>
                            <div className='card'>
                                <img className='text-center ml-3 mt-1' style={{width: '95%', borderRadius: '10px', height: '90%'}} src={img[0]} alt="" />
                                <h2 className='mt-2 ml-2'>Futa Website Clonning</h2>
                                <p className='mt-2 ml-2'>A University Website. Built with HTML, CSS and javascript</p>
                                <button className='btn btn-primary'>Check Out</button>
                                <a href='#' className='btn btn-primary mt-2'>Github</a>
                            </div>
                        </div>
                </div>
         </div>
                <div className='footer'>
                    <div className='container mt-2'>
                    <h2 style={{color: 'white', position: 'absolute'}} className='mt-3 text-center'>Dev Godwin</h2>
                    </div>
                </div>
    </div>
  )
}

export default Project